import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export const ProtectedRoute = ({ role, children }) => {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="min-h-screen flex items-center justify-center" data-testid="auth-loading">
        <div className="h-8 w-8 rounded-full border-2 border-[#0d2f4d] border-t-transparent animate-spin" />
      </div>
    );
  if (user === false) return <Navigate to="/signin" replace />;
  if (role && user.role !== role)
    return <Navigate to={user.role === "candidate" ? "/candidate" : "/employer"} replace />;
  return children;
};
